<adapt-button-toggle-group adaptToolbarContent
                           alignment="center"
                           [value]="page"
                           (valueChange)="updateUrl($event)">
    <ng-container *ngFor="let tab of tabs">
        <button *ngIf="tab.visible"
                [adaptToggleGroupButton]="tab.toggleValue"
                [adaptButtonIcon]="tab.icon">{{tab.text}}</button>
    </ng-container>
</adapt-button-toggle-group>

<adapt-two-column-layout *ngIf="page !== ActivityPage.Calendar"
                         [fullPage]="true"
                         leftColumnWidthClasses="col p-0"
                         rightColumnWidthClasses="col-auto">
    <div *ngIf="page === ActivityPage.Pathway"
         left-column
         class="p-3">
        <ng-content select="[activity-pathway-page-before]"></ng-content>

        <adapt-workflows-dashboard-element [person]="currentPerson"></adapt-workflows-dashboard-element>

        <ng-content select="[activity-pathway-page-after]"></ng-content>
    </div>

    <ng-container *ngIf="page === ActivityPage.Status"
                  left-column>
        <p *ngIf="!activitiesService.hasAnyActivityType"
           class="p-3">
            There are no activities available for you at this moment.
            <ng-container *adaptIfAlto="true">Try completing some pathways first.</ng-container>
        </p>

        <p *ngIf="!hasAnyVisibleStatuses"
           class="p-3">There are no activities matching the current filter.</p>

        <adapt-layout-manager innerClass="h-100 pt-3 m-0 activity-layout"
                              dynamicColumnClass="col-sm-12"
                              page="activity-status"
                              [fullPage]="true"
                              [allowEditing]="true"
                              [columnSizePresets]="columnSizePresets"
                              [componentSizePresets]="componentSizePresets"
                              *adaptRerender="updateLayout$">
            <adapt-layout-column class="col-md-12">
                <ng-container *ngTemplateOutlet="errorAlert"></ng-container>

                <ng-container *ngFor="let section of StatusSections; trackBy: statusSectionTrackBy">
                    <adapt-layout-component *ngIf="activitiesService.isActivityStatusVisible(section.group)"
                                            id="activity-{{section.group.toLowerCase()}}">
                        <adapt-activity-section-collapsible [section]="section"
                                                            [count]="section.displayedCount"
                                                            [totalCount]="section.totalCount"
                                                            [countTooltip]="activitySectionTooltip"
                                                            fallbackText="Great work, you have nothing that is {{section.group}}."
                                                            [isLoading]="anySectionIsLoading">
                            <ng-container *ngIf="activitiesService.asStatusGroupRecord(activitiesGroupedByStatus?.[section.group] | keyvalue) as activityStatusGroup">
                                <ng-container *ngFor="let group of activityStatusGroup; trackBy: keyValueTrackBy">
                                    <ng-container *ngIf="CulturalActivityMetadataByType[group.key] as typeMetadata">
                                        <adapt-universal-dashboard-element *ngIf="group.value.length > 0 && activitiesService.isActivityTypeVisible(typeMetadata)"
                                                                           [name]="typeMetadata.title"
                                                                           [background]="false"
                                                                           [nested]="true"
                                                                           [url]="routes[group.key]"
                                                                           id="activity-{{typeMetadata.type.toLowerCase()}}">
                                            <div class="d-flex flex-row flex-wrap gap-3">
                                                <ng-container *ngFor="let activity of group.value; trackBy: activityTrackBy">
                                                    <ng-container *ngTemplateOutlet="activityTemplate; context: {$implicit: activity, highlight: false}"></ng-container>
                                                </ng-container>
                                            </div>
                                        </adapt-universal-dashboard-element>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </adapt-activity-section-collapsible>
                    </adapt-layout-component>
                </ng-container>
            </adapt-layout-column>
        </adapt-layout-manager>
    </ng-container>

    <ng-container *ngIf="page === ActivityPage.Activity"
                  left-column>
        <p *ngIf="!activitiesService.hasAnyActivityType"
           class="p-3">
            There are no activities available for you at this moment.
            <ng-container *adaptIfAlto="true">Try completing some pathways first.</ng-container>
        </p>

        <p *ngIf="!hasAnyVisibleTypes"
           class="p-3">There are no activities matching the current filter.</p>

        <adapt-layout-manager innerClass="h-100 pt-3 m-0 activity-layout"
                              page="activity"
                              [fullPage]="true"
                              [allowEditing]="true"
                              [columnSizePresets]="columnSizePresets"
                              [componentSizePresets]="componentSizePresets"
                              *adaptRerender="updateLayout$">
            <adapt-layout-column *ngFor="let column of ActivityColumns; let columnCount = count"
                                 class="col-lg-{{columnCount > 1 ? 6 : 12}}">
                <ng-container *ngFor="let section of column; trackBy: sectionTrackBy">
                    <adapt-layout-component *ngIf="activitiesService.isActivityTypeVisible(section)"
                                            id="activity-{{section.type.toLowerCase()}}">
                        <ng-container *ngIf="section.isCulturalActivityType; else nonCadenceActivity">
                            <adapt-activity-section-collapsible *ngIf="activitiesGroupedByType?.[section.type] as activities"
                                                                [section]="section"
                                                                [count]="getDisplayedCountForGroup(activities)"
                                                                [totalCount]="activities.totalCount"
                                                                [countTooltip]="activitySectionTooltip"
                                                                [fallbackText]="getFallbackText(section)"
                                                                [isLoading]="!!sectionIsLoading.get(section.type)"
                                                                [error]="sectionError.get(section.type)">
                                <adapt-universal-dashboard-element *ngIf="activities.overdue.length > 0 && activitiesService.isActivityStatusVisible(ActivityStatus.Overdue)"
                                                                   name="Activities due"
                                                                   [background]="false"
                                                                   [nested]="true">
                                    <div class="d-flex flex-row flex-wrap gap-3">
                                        <ng-container *ngFor="let activity of activities.overdue; trackBy: activityTrackBy">
                                            <ng-container *ngTemplateOutlet="activityTemplate; context: {$implicit: activity, highlight: true}"></ng-container>
                                        </ng-container>
                                    </div>
                                </adapt-universal-dashboard-element>

                                <adapt-universal-dashboard-element *ngIf="activities.upcoming.length > 0 && activitiesService.isActivityStatusVisible(ActivityStatus.Upcoming)"
                                                                   name="Upcoming"
                                                                   [background]="false"
                                                                   [nested]="true">
                                    <div class="d-flex flex-row flex-wrap gap-3">
                                        <ng-container *ngFor="let activity of activities.upcoming; trackBy: activityTrackBy">
                                            <ng-container *ngTemplateOutlet="activityTemplate; context: {$implicit: activity, highlight: false}"></ng-container>
                                        </ng-container>
                                    </div>
                                </adapt-universal-dashboard-element>
                            </adapt-activity-section-collapsible>
                        </ng-container>
                    </adapt-layout-component>

                    <ng-template #nonCadenceActivity>
                        <adapt-personal-work-activity-section *ngIf="section.type === NonCulturalActivityType.Actions && activitiesService.isItemGroup(activitiesGroupedByType?.[section.type], section.type) as activities"
                                                              [activityGroup]="activities"
                                                              [countTooltip]="activitySectionTooltip"
                                                              [isLoading]="!!sectionIsLoading.get(section.type)"
                                                              [(blurPrivateActions)]="blurPrivateActions"
                                                              [error]="sectionError.get(section.type)"
                                                              [fallbackText]="getFallbackText(section)"></adapt-personal-work-activity-section>
                        <adapt-personal-objectives-activity-section *ngIf="section.type === NonCulturalActivityType.Objectives && activitiesService.isObjectiveGroup(activitiesGroupedByType?.[section.type], section.type) as activities"
                                                                    [activityGroup]="activities"
                                                                    [countTooltip]="activitySectionTooltip"
                                                                    [isLoading]="!!sectionIsLoading.get(section.type)"
                                                                    [error]="sectionError.get(section.type)"
                                                                    [fallbackText]="getFallbackText(section)"></adapt-personal-objectives-activity-section>
                        <adapt-personal-meetings-activity-section *ngIf="section.type === NonCulturalActivityType.Meetings && activitiesService.isMeetingGroup(activitiesGroupedByType?.[section.type], section.type) as activities"
                                                                  [activityGroup]="activities"
                                                                  [countTooltip]="activitySectionTooltip"
                                                                  [isLoading]="!!sectionIsLoading.get(section.type)"
                                                                  [error]="sectionError.get(section.type)"
                                                                  [fallbackText]="getFallbackText(section)"></adapt-personal-meetings-activity-section>
                    </ng-template>
                </ng-container>
            </adapt-layout-column>
        </adapt-layout-manager>
    </ng-container>
</adapt-two-column-layout>

<adapt-activity-calendar *ngIf="page === ActivityPage.Calendar"
                         [activityTemplate]="activityTemplate"
                         [routes]="routes"
                         [shouldUpdate$]="shouldUpdate$">
    <ng-container *ngTemplateOutlet="errorAlert"></ng-container>
</adapt-activity-calendar>

<adapt-activity-filter *ngIf="page !== ActivityPage.Pathway"
                       [isCalendarView]="page === ActivityPage.Calendar"
                       (filterChange)="onFilterChanged($event)"></adapt-activity-filter>

<ng-template #activityTemplate
             let-activity
             let-highlight="highlight"
             let-actionable="actionable">
    <adapt-activity-card *ngIf="activitiesService.isCulturalActivity(activity)"
                         [activity]="activity"
                         [highlightOverdue]="highlight"
                         [allowActions]="actionable ?? true"
                         (activityComplete)="onActivityCompleted(activity)"></adapt-activity-card>

    <adapt-kanban-card *ngIf="activitiesService.isItem(activity)"
                       [item]="activity"
                       [highlight]="highlight"
                       [blurSensitiveContent]="blurPrivateActions"
                       [draggable]="false"
                       [showAssignee]="false"></adapt-kanban-card>

    <adapt-meeting-dashboard-card *ngIf="activitiesService.isMeeting(activity)"
                                  [meeting]="activity"
                                  [showTeamName]="true"
                                  [compact]="false"
                                  [showStartButton]="actionable ?? true"></adapt-meeting-dashboard-card>

    <div *ngIf="activitiesService.isMeetingTeamGroup(activity)">
        <adapt-link-team-meetings-page *adaptIfAlto="false"
                                       [team]="activity.team"
                                       class="d-block mb-1"></adapt-link-team-meetings-page>
        <div class="d-flex flex-column flex-wrap gap-3">
            <adapt-meeting-dashboard-card *ngFor="let meeting of activity.meetings"
                                          [meeting]="meeting"
                                          [showTeamName]="false"
                                          [compact]="false"></adapt-meeting-dashboard-card>
        </div>
    </div>

    <adapt-objective-dashboard-summary *ngIf="activitiesService.isObjective(activity)"
                                       [objective]="activity"
                                       [displayAssignee]="false"
                                       [class.overdue]="activity.isOverdue && highlight"></adapt-objective-dashboard-summary>
    <div *ngIf="activitiesService.isObjectiveTeamGroup(activity)">
        <adapt-link-objectives-page *adaptIfAlto="false"
                                    [team]="activity.team"
                                    class="d-block mb-1"></adapt-link-objectives-page>
        <div class="d-flex flex-column flex-wrap gap-3">
            <adapt-objective-dashboard-summary *ngFor="let objective of activity.objectives"
                                               [objective]="objective"
                                               [displayAssignee]="false"
                                               [class.overdue]="objective.isOverdue && highlight"></adapt-objective-dashboard-summary>
        </div>
    </div>
</ng-template>

<ng-template #errorAlert>
    <div *ngIf="hasAnyErrors"
         class="alert alert-danger"
         role="alert">
        There was a problem loading the following activities:
        <ul>
            <li *ngFor="let errorGroup of groupedErrors">
                <b>{{errorGroup.items.join(", ")}}:</b> {{errorGroup.key}}
            </li>
        </ul>
    </div>
</ng-template>
